import { ReportLoader } from './ReportLoader'
import Icon from 'src/shared/icons'
import { Modal } from 'src/shared/components/layout/modal/Modal'

const ReportLoaderModal = ({ isOpen }: { isOpen: boolean }) => {
    return (
        <Modal isOpen={isOpen} width={278} height={208}>
            <ReportLoader title='Generando reporte...'>
                <Icon name='FolderChart' color='var(--primary)' width={40} height={40} />
            </ReportLoader>
        </Modal>
    )
}

export default ReportLoaderModal